import { render } from "./CustomerDetail.vue?vue&type=template&id=41666f9a&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"

import "./CustomerDetail.vue?vue&type=style&index=0&id=41666f9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41666f9a"]])

export default __exports__